import { render, staticRenderFns } from "./CrossSellingDialog.vue?vue&type=template&id=3f0767ed"
import script from "./CrossSellingDialog.vue?vue&type=script&lang=js"
export * from "./CrossSellingDialog.vue?vue&type=script&lang=js"
import style0 from "./CrossSellingDialog.vue?vue&type=style&index=0&id=3f0767ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports